import {isNotNil} from 'ramda';

import type {DeadStockSnapshotQuery} from '@prompt-bridge/shared/validations';

const PATH = '/api/v1/report/dead-stock-snapshot';

export function buildDeadStockSnapshotUrl(filters: DeadStockSnapshotQuery) {
  const params = new URLSearchParams();

  if (isNotNil(filters.asOf)) {
    params.set('asOf', filters.asOf);
  }
  if (isNotNil(filters.bucket)) {
    params.set('bucket', filters.bucket);
  }
  if (isNotNil(filters.sortBy)) {
    params.set('sortBy', filters.sortBy);
  }
  if (isNotNil(filters.sortDirection)) {
    params.set('sortDirection', filters.sortDirection);
  }
  if (isNotNil(filters.offset)) {
    params.set('offset', String(filters.offset));
  }
  for (const id of filters.branch ?? []) {
    params.append('branch', id);
  }
  for (const id of filters.warehouse ?? []) {
    params.append('warehouse', id);
  }
  for (const id of filters.manufacturer ?? []) {
    params.append('manufacturer', id);
  }
  const query = params.toString();

  return query ? `${PATH}?${query}` : PATH;
}
